import { render, staticRenderFns } from "./AdminJobApplicantsList.vue?vue&type=template&id=64e8ef83&scoped=true"
import script from "./AdminJobApplicantsList.vue?vue&type=script&lang=js"
export * from "./AdminJobApplicantsList.vue?vue&type=script&lang=js"
import style0 from "./AdminJobApplicantsList.vue?vue&type=style&index=0&id=64e8ef83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8ef83",
  null
  
)

export default component.exports